export const ICON_PATH = 'assets/icons';
export const ICONS = [
  'logout',
  'logout-empty',
  'all-timesheets',
  'entitlements',
  'instruction',
  'monthly-reports',
  'my-timesheets',
  'photo',
  'report-issue',
  'settings',
  'tool-support',
  'pdf',
  'excel',
  'terminate',
  'arrow-drop-down',
  'archive'
];
